import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetGroupQuery } from "../../store/api/groupApi";
import { GroupDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "group";
export const GroupDetailInitializer: React.FC = () => {
  const { org: orgName, group: groupName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/group/${groupName}`;

  const { data: group, isLoading, isFetching, isError, error, refetch } = useGetGroupQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!group && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="group" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !group) {
    return <IncorrectItem kind="group" canCreate={true} />;
  }

  return <GroupDetailForm group={group} />;
};
